'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var component$n = require('./component-0f14c06d.js');
var styles$k = require('./styles-8d4a3ad6.js');

var DriveToMobileModal = function (_a) {
    var title = _a.title, description = _a.description, isVisible = _a.isVisible, onClose = _a.onClose;
    return (React__default.createElement(component$n.ModalWrapper, { content: (React__default.createElement(styles$k.DriveToMobileWrapper, null,
            React__default.createElement(styles$k.Content, null,
                React__default.createElement(styles$k.Title, null, title),
                React__default.createElement(styles$k.Description, null, description),
                React__default.createElement(styles$k.StoresLinksWrapper, null,
                    React__default.createElement("a", { href: "https://www.apple.com/app-store/", target: "_blank", rel: "noreferrer noopener" },
                        React__default.createElement(styles$k.AppStoreButton, null)),
                    React__default.createElement("a", { href: "https://play.google.com/store/apps", target: "_blank", rel: "noreferrer noopener" },
                        React__default.createElement(styles$k.GooglePlayButton, null)))))), visible: isVisible, withExitButton: true, onClose: onClose }));
};

exports.DriveToMobileModal = DriveToMobileModal;
